import $ from 'jquery';

const LoadNumbers = (el) => {
    const $el = $(el);
    $el.click(function (e) {
        e.preventDefault();
        const offset = $el.data('offset');

        wp.ajax.post('load_numbers', {
            offset: offset,
        })
            .done(function(response) {
                $('.js-numbers-container').append(response.output);
                if (parseInt(response.nextNumbers) === 0) {
                    $el.hide();
                }
                $el.data('offset', offset + 6);
            })
            .fail(function() {
                console.log('Error loading numbers');
            });
    });
};

export default LoadNumbers;
